import { render } from "./ComponentDialogMensagem.vue?vue&type=template&id=f821633a"
import script from "./ComponentDialogMensagem.vue?vue&type=script&lang=js"
export * from "./ComponentDialogMensagem.vue?vue&type=script&lang=js"

import "./ComponentDialogMensagem.vue?vue&type=style&index=0&id=f821633a&lang=css"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__